module.exports = __webpack_public_path__ + "img/taco.9d7c12cf.svg";